export default "__VITE_ASSET__BtEdaHX7__"